export const useSportsBookV2 = () => {
    const state = {
        scriptUrl: window.appContext.Config.sportsbookV2.scriptUrl,
        iframeUrl: window.appContext.Config.sportsbookV2.iframeUrl,
    };

    const _create = (url) => {
        (function (b, e, t, s) {
            b[t] =
                b[t] ||
                function () {
                    b[t]._q.push(arguments);
                };
            b[t]._q = b[t]._q || [];
            const o = e.createElement("script");
            o.src = s;
            e.head.appendChild(o);
        })(window, document, "Sportsbook", url);
    };

    const init = async (container = "#sportsBetting") => {
        return new Promise((resolve, reject) => {
            const store = window.Alpine.store("services");

            // cancellable handler for windows "message" event
            const handleSportsbookMessage = (event) => {
                if (event.data?.type === "sportsbook:initialized") {
                    onLoaded();
                    window.removeEventListener(
                        "message",
                        handleSportsbookMessage,
                    );
                }
            };

            let isResolved = false;

            // callback executed when sportsbook is loaded
            const onLoaded = () => {
                if (isResolved) return; // Prevent multiple calls
                isResolved = true;

                store.sportsBookV2.loaded = true;
                window.removeEventListener("message", handleSportsbookMessage);

                // Small delay to ensure iframe is fully settled
                setTimeout(() => {
                    resolve();
                }, 500);
            };

            // Fallback timeout - if no signal after 15 seconds, assume it loaded
            const fallbackTimeout = setTimeout(() => {
                if (!isResolved) {
                    console.warn(
                        "[Sportsbook] No initialization signal received after 15s. Assuming loaded.",
                    );
                    onLoaded();
                }
            }, 15000);

            // check if store is populated ;
            if (!store.sportsBookV2.created) {
                _create(state.scriptUrl + "/init-sportsbook");
                store.sportsBookV2.created = true;
            }

            // check if sportsBook was already initialized.
            if (store.sportsBookV2.initialized) {
                try {
                    window.Sportsbook("kill");
                } finally {
                    store.sportsBookV2.initialized = false;
                }
            }

            // as it was killed, it needs to be loaded again.
            store.sportsBookV2.loaded = false;

            // re-init the component.
            window.Sportsbook("init", {
                container: container,
                iframeSrc: state.iframeUrl,
                getAuthToken: async () =>
                    Promise.resolve(window.appContext.Player.uuid), // function that return Promise with auth token
                listeners: {
                    onPageLoaded: (payload) => {
                        onLoaded();
                    },
                    /*onSignIn: () => {
                        window.location.href = "";
                    },
                    onSignUp: () => {
                        window.location.href = "";
                    },
                    onDeposit: () => {
                        window.location.href = "";
                    },*/
                },
            });

            // flag init as completed
            store.sportsBookV2.initialized = true;

            // pass the auth status
            if (window.appContext?.Player?.uuid) {
                window.Sportsbook("setAuthStatus", { authStatus: "LOGGED_IN" });
            }

            // listen to global loaded message
            window.addEventListener("message", handleSportsbookMessage);
        });
    };

    return {
        init,
    };
};
